<template>
  <div class="header">
    <div class="logo" v-if="company_sn=='R'"><img src="../assets/logo/logo.jpg" alt="" /></div>
    <div class="logo-wz" v-if="company_sn=='R'">
      <div class="logo-wz-title">美的夢</div>
      <div class="logo-wz-subtitle">100%本港原創品牌</div>
    </div>

    <div class="logo" v-if="company_sn=='S'"><img src="../assets/logo/rlogo.jpg" alt="" /></div>
    <div class="logo-wz" v-if="company_sn=='S'">
      <div class="logo-wz-title">森美奧</div>
      <div class="logo-wz-subtitle">100%本港原創品牌</div>
    </div>
    <div class="menu">
      <div class="sidebar cantselect">
        <el-menu
          class="sidebar-el-menu"
          :default-active="onRoutes"
          text-color="#303133"
          active-text-color="#409EFF"
          unique-opened
          router
          mode="horizontal"
        >
          <template v-for="item in items">
            <template v-if="item.subs">
              <el-submenu :index="item.sysmenu" :key="item.sysmenu">
                <template #title>
                  <i :class="item.menuicon"></i>
                  <span>{{ item.menutext }}</span>
                </template>
                <template v-for="subItem in item.subs">
                  <el-submenu
                    v-if="subItem.subs"
                    :index="subItem.sysmenu"
                    :key="subItem.sysmenu"
                  >
                    <template #title>{{ subItem.menutext }}</template>
                    <el-menu-item
                      v-for="(threeItem, i) in subItem.subs"
                      :key="i"
                      :route="threeItem.router"
                      :index="threeItem.sysmenu"
                      >{{ threeItem.menutext }}</el-menu-item
                    >
                  </el-submenu>
                  <el-menu-item
                    v-else
                    :index="subItem.sysmenu"
                    :route="subItem.router"
                    :key="subItem.sysmenu"
                    >{{ subItem.menutext }}</el-menu-item
                  >
                </template>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item
                :index="item.sysmenu"
                :route="item.router"
                :key="item.sysmenu"
              >
                <i :class="item.menuicon"></i>
                <span>{{ item.menutext }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>
    </div>
    <div class="mc"  v-if="company_sn=='R'" @click="qiehuan('R')">森美奧品牌</div>
    <div class="mc" v-if="company_sn=='S'" @click="qiehuan('S')">美的夢品牌</div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      company_sn:"R",
      items: [
        {
          sysmenu: "home",
          menutext: "首頁",
          router: "/home",
        },
        {
          sysmenu: "200",
          menutext: "產品展示",
          subs: [
            {
              sysmenu: "cd",
              menutext: "床褥系列",
              router: "/goods/cd",
            },
            {
              sysmenu: "cp",
              menutext: "床品系列",
              router: "/goods/cp",
            },
            {
              sysmenu: "sf",
              menutext: "梳化系列",
              router: "/goods/sf",
            },
          ],
        },
        {
          sysmenu: "about",
          menutext: "品牌文化",
          router: "/about",
        },
        {
          sysmenu: "contact",
          menutext: "聯繫我們",
          router: "/contact",
        },
      ],
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
  },
  created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.company_sn=sessionStorage.getItem("company_sn")
    }else{
      sessionStorage.setItem("company_sn",this.company_sn);
      var t
      clearTimeout(t)
      var _that=this
      t=setTimeout(function(){
        _that.$router.go(0);
      },500
      )

    }
  },
  methods: {
    qiehuan(id){
      if(id=='R'){
        this.company_sn='S'
        sessionStorage.setItem("company_sn", "S");
      }else{
        this.company_sn='R'
        sessionStorage.setItem("company_sn","R");
      }
      var t
      clearTimeout(t)
      var _that=this
      t=setTimeout(function(){
        _that.$router.go(0);
      },500
      )
    }
  },
};
</script>

<style scoped>
.el-menu.el-menu--horizontal {
  border-bottom: 0px;
  font-size: 50px;
}
.header {
  display: flex;
  height: 100px;
  width: 100%;
  justify-content: center;
}
.logo {
  width: 90px;
  padding-top: 25px;
}
.logo img {
  width: 90px;
  height: 60px;
}

.logo-wz {
  height: 80px;
  width: 160px;
  padding-top: 25px;
  margin-right: 180px;
}
.logo-wz-title {
  font-size: 28px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #409eff;
}
.logo-wz-subtitle {
  font-size: 12px;
  color: #409eff;
}

.menu {
  width: 400px;
  height: 100px;
  line-height: 100px;
}
.sidebar {
  margin-top: 14px;
}
.mc{
  height: 90px;
  line-height: 90px;
  font-size: 14px;
}
</style>